<template>
  <md-card-actions>
    <md-button
      v-if="this.$route.query.fromQuote === true"
      class="md-primary md-sm"
      @click="backToQuoteItems()"
    >
      <span class="md-label">
        <md-icon class="material-icons">keyboard_backspace</md-icon> </span
      >View other Quotes
    </md-button>
    <md-button
      v-if="this.$route.query.fromFilter === true"
      class="md-primary md-sm"
      @click="backToFilteredStatInspItems()"
    >
      <span class="md-label">
        <md-icon class="material-icons">keyboard_backspace</md-icon> </span
      >View other {{ type(statInspItem.statInspItemTypeId) }}/{{
        status(statInspItem.statInspItemStatusId).name
      }}
      Stat Insp Items
    </md-button>
    <md-button class="md-primary md-sm" @click="backToStatInsp()">
      <span class="md-label">
        <md-icon class="material-icons">keyboard_backspace</md-icon> </span
      >View Parent Stat Insp
    </md-button>
    <md-button
      class="md-success md-sm"
      v-if="
        statInspItem.canCloseAgainstPreviousReport &&
          (statInspItem.statInspItemStatusId === 1 ||
            statInspItem.statInspItemStatusId === 6)
      "
      @click="closeAgainstPrevious()"
    >
      <span class="md-label">
        <md-icon class="material-icons">restore</md-icon>
      </span>
      Close against previous Stat. Insp.
    </md-button>
    <status-button
      :statusId="1"
      :classColour="status(1).colour"
      icon="restore"
      text="Reopen"
      :visible="setVisibility(1)"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="7"
      :classColour="status(7).colour"
      icon="attach_money"
      text="Issue Quote"
      :visible="setVisibility(7)"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="2"
      :classColour="status(2).colour"
      icon="check"
      :text="'Set to ' + status(2).name"
      role="stat-insp"
      :visible="setVisibility(2)"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="4"
      :classColour="status(4).colour"
      icon="help_outline"
      :text="'Set to ' + status(4).name"
      role="stat-insp"
      :visible="setVisibility(4)"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="5"
      :classColour="status(5).colour"
      icon="check"
      :text="'Set to ' + status(5).name"
      :visible="setVisibility(5)"
      @change-status="changeStatus"
    ></status-button>
  </md-card-actions>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "stat-insp-item-actions",
  computed: {
    ...mapGetters({
      statInsp: "stat-insp/statInsp",
      statInspItem: "stat-insp/statInspItem",
      status: "stat-insp/statInspItemStatus",
      type: "stat-insp/statInspItemType",
      quoteStatus: "quote/getQuoteStatus"
    })
  },
  methods: {
    changeStatus(statusId) {
      this.$emit("change-status", statusId);
    },
    backToFilteredStatInspItems() {
      this.$router.push({
        name: "Stat Insp Items Filter",
        query: {
          typeId: this.statInspItem.statInspItemTypeId,
          statusId: this.statInspItem.statInspItemStatusId
        }
      });
    },
    backToStatInsp() {
      this.$router.push({
        name: "Statutory Inspection",
        params: { statInspId: this.$route.params.statInspId }
      });
    },
    backToQuoteItems() {
      this.$router.push({
        name: this.quoteStatus(this.statInspItem.liveQuote.quoteStatus).list
      });
    },
    closeAgainstPrevious() {
      this.$emit("close-against-previous");
    },
    setVisibility(statusId) {
      if (this.statInsp.isPartial) return false;

      switch (statusId) {
        case 1:
          return this.statInspItem.statInspItemStatusId === 4;
        case 2:
          return this.statInspItem.statInspItemStatusId === 1;
        case 4:
          return (
            this.statInspItem.statInspItemStatusId === 1 ||
            (this.statInspItem.statInspItemStatusId === 2 &&
              this.statInspItem.liveQuote === null)
          );
        case 5:
          return this.statInspItem.statInspItemStatusId == 4;
        case 7:
          return this.statInspItem.statInspItemStatusId == 1;
      }
    }
  }
};
</script>

<style></style>
